// import Swiper JS
import Swiper from 'swiper';
import { Navigation, FreeMode, A11y, Autoplay } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import './gallery-slider.scss'; // Import the custom styles for the gallery slider
import { themeSliderSettings } from './slider-settings.js';


document.addEventListener('DOMContentLoaded', function () {
    let swiperToDo = document.querySelectorAll('.wp-block-gallery.is-style-gallery-slider');
    swiperToDo.forEach((elem) => {
        //create unique id for swiper
        const uniqueId = 'swiper-' + Math.random().toString(36).substring(2, 15);
        elem.id = uniqueId;

        // prepare the swiper elements
        const baseElem = elem;
        //addSeperateNavigationButtons(baseElem, uniqueId);

        //wrap content in swiper container
        baseElem.classList.add('swiper');
        baseElem.classList.add('themeSwiperStyle');
        let swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');
        baseElem.appendChild(swiperWrapper);

        //move content to slide
        let content = baseElem.querySelectorAll('figure');
        content.forEach((elem) => {
            elem.classList.add('swiper-slide');
            swiperWrapper.appendChild(elem);
        });


        //add navigation
        let navPrev = document.createElement('div');
        navPrev.classList.add('swiper-button-prev');
        baseElem.appendChild(navPrev);
        let navNext = document.createElement('div');
        navNext.classList.add('swiper-button-next');
        baseElem.appendChild(navNext);


        const settings = Object.assign(themeSliderSettings, {
            spaceBetween: 3,
            modules: [Navigation, FreeMode, A11y, Autoplay],
            autoplay: {
                delay: 5000,
            },
            navigation: {
                //nextEl: '#' + uniqueId + '-next',
                //prevEl: '#' + uniqueId + '-prev',
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
        });
        settings.a11y.containerMessage = 'Bilder Slideshow';
        // Initialize Swiper
        const swiper = new Swiper(baseElem, settings);
    });
});


const addSeperateNavigationButtons = (baseElem, uniqueId) => {
    let parentElem = baseElem.parentElement;
    let navContainer = document.createElement('div');
    navContainer.classList.add('custom-swiper-nav');
    parentElem.prepend(navContainer);
    navContainer.setAttribute('aria-label', 'Bilder Navigation');
    navContainer.setAttribute('role', 'navigation');
    navContainer.setAttribute('aria-controls', uniqueId);
    navContainer.id = uniqueId + '-nav';

    let navPrev = document.createElement('div');
    navPrev.classList.add('custom-swiper-button-prev');
    navPrev.setAttribute('aria-label', 'Vorheriges Bild');
    navPrev.setAttribute('aria-controls', uniqueId);
    navPrev.setAttribute('role', 'button');
    navPrev.setAttribute('tabindex', '0');
    navPrev.id = uniqueId + '-prev';
    navContainer.appendChild(navPrev);
    navPrev.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 16L16 24M16 24L24 32M16 24H32" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M40 13.334V34.666C40 35.3665 39.862 36.0601 39.594 36.7072C39.3259 37.3544 38.933 37.9424 38.4377 38.4377C37.9424 38.933 37.3544 39.3259 36.7072 39.594C36.0601 39.862 35.3665 40 34.666 40H13.334C12.6335 40 11.9399 39.862 11.2928 39.594C10.6456 39.3259 10.0576 38.933 9.56229 38.4377C9.06698 37.9424 8.67409 37.3544 8.40603 36.7072C8.13797 36.0601 8 35.3665 8 34.666V13.334C8 11.9193 8.56197 10.5626 9.56229 9.56229C10.5626 8.56197 11.9193 8 13.334 8H34.666C35.3665 8 36.0601 8.13797 36.7072 8.40603C37.3544 8.67409 37.9424 9.06698 38.4377 9.56229C38.933 10.0576 39.3259 10.6456 39.594 11.2928C39.862 11.9399 40 12.6335 40 13.334Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    let navNext = document.createElement('div');
    navNext.classList.add('custom-swiper-button-next');
    navNext.setAttribute('aria-label', 'Nächstes Bild');
    navNext.setAttribute('aria-controls', uniqueId);
    navNext.setAttribute('role', 'button');
    navNext.setAttribute('tabindex', '0');
    navNext.id = uniqueId + '-next';
    navNext.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 16L16 24M16 24L24 32M16 24H32" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M40 13.334V34.666C40 35.3665 39.862 36.0601 39.594 36.7072C39.3259 37.3544 38.933 37.9424 38.4377 38.4377C37.9424 38.933 37.3544 39.3259 36.7072 39.594C36.0601 39.862 35.3665 40 34.666 40H13.334C12.6335 40 11.9399 39.862 11.2928 39.594C10.6456 39.3259 10.0576 38.933 9.56229 38.4377C9.06698 37.9424 8.67409 37.3544 8.40603 36.7072C8.13797 36.0601 8 35.3665 8 34.666V13.334C8 11.9193 8.56197 10.5626 9.56229 9.56229C10.5626 8.56197 11.9193 8 13.334 8H34.666C35.3665 8 36.0601 8.13797 36.7072 8.40603C37.3544 8.67409 37.9424 9.06698 38.4377 9.56229C38.933 10.0576 39.3259 10.6456 39.594 11.2928C39.862 11.9399 40 12.6335 40 13.334Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    navContainer.appendChild(navNext);
}
